import {AuthLayout} from '@cypro/ui/components'
import {createFileRoute, Outlet} from '@tanstack/react-router'

export const Route = createFileRoute('/auth')({
  component: Layout,
})

function Layout() {
  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  )
}
